/* przekierowanie do tej strony przy użyciu tokena */
import { Navigate, useParams } from "react-router-dom";
import { IUrlRedirectToken } from "../../interfaces/IUrl";
import { useContext } from "react";
import { UserContext } from "../../context/UserContext";
import RequestClass from "../../classes/RequestClass";

interface IRedirectToken {
    token?: boolean; // jeżeli true to oczekuję na przekazanie tokena do logowania się
}

export const RedirectToken = (props: IRedirectToken) => {
    const urlParams = useParams<IUrlRedirectToken>();
    const { setIsLogged } = useContext(UserContext);

    if (urlParams.token == undefined) {
        return <Navigate to="/login" />;
        //console.log("Będzie logowanko za pomocą tokenka");
    }

    // console.log(urlParams.token);
    RequestClass.setToken(urlParams.token);
    //sessionStorage.setItem("access_token", urlParams.token);
    setIsLogged(true);
    return <Navigate to="/konto" />;
    //return <>Przekierowanie do panelu użytkownika, proszę czekać</>;
};
//localhost:3001/szkolenia/redirect/VGy47jboLnHUZnDvcAiI43GuH53VfMe
